module.exports = __webpack_public_path__ + "img/teams-logo-small.f8308aa1.png";